export default {
  loading: 'Loading...',
  emptyState: 'No objects',
  emptyStateAndFilterActive: 'Objects matching the selected filters were not found'
}
